import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class DropdownsScenarioIndexComponent extends Component {
  @service store;

  get scenarios() {
    return this.store.peekAll('investment-scenario').map((item) => ({
      label: item.title,
      value: item.id,
    }));
  }
}
